import React from "react";

import UiLabelTag from "@/components/Ui/Label/Tag";
import { SupHeading, SupText, SupUserAnon007 } from "@repo/core-ui";

export default function UiLabelMultiStep() {
  return (
    <UiLabelTag
      icon={<SupUserAnon007 />}
      label="Multi-Step vault"
      tooltipContent={
        <div className="space-y-2">
          <div className="inline-flex w-full flex-nowrap items-center space-x-1 text-primary-600">
            <SupUserAnon007 className="h-6 w-6 drop-shadow-md" />
            <SupHeading variant="h6">Multi-Step Vault</SupHeading>
          </div>
          <SupText variant="subtitle1" as="div" className="text-neutral-900">
            This vault has multiple steps required for withdrawal. You will receive vault shares when you withdraw.
          </SupText>
        </div>
      }
    />
  );
}
